// extracted by mini-css-extract-plugin
export default {"AppsButton":"AppsButton_AppsButton__qKxa7","Icon":"AppsButton_Icon__ZMzZE","White":"AppsButton_White__6LatX","NotificationCount":"AppsButton_NotificationCount__KWu+E"};